export default {
  SET_DETAILS(state, details) {
    state.details = details;
  },
};
